import {LogRocketController} from '../ui_log_rocket/LogRocketController'
import {GameStateEnums} from '../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {isCrawler} from './BotAnalytics'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {UISessionRecorder} from '../ui_session_recorder/UISessionRecorder'
import {uiGameManager} from '../EntryShared'
import {UIDeviceController} from '../ui_html/UIDeviceController'

declare const gtag: any

interface UIGoogleAnalyticsEvent {
    category: CA.Category
    label: CA.Label | string
    amount: number
    sendAndInvalidateOn?: UIGameEventEnums | undefined
}

export module CA { // Client Analytics

    export let logRocket: LogRocketController | undefined
    export let sessionRecorder: UISessionRecorder

    export enum Category {
        Funnel = 'Funnel',
        General = 'General',
        LandingPage = 'LandingPage',
        Lobby = 'Lobby',
        Room = 'Room',
        Game = 'Game',
        EndGame = 'EndGame',
        Profile = 'Profile',
        Store = 'Store',
        Community = 'Community',
        Mobile = 'Mobile',
        HeaderProfile = 'HeaderProfile',
    }

    export enum Label {
        // Funnel
        FunnelNewUserEnteredSite = 'funnel_new_user_entered_site',
        FunnelStartedGame = 'funnel_started_game',
        FunnelGameGetResources = 'funnel_game_get_resources',
        FunnelGameClickDice = 'funnel_game_click_dice',
        FunnelGameClickPassTurn = 'funnel_game_click_pass_turn',
        FunnelGameConfirmBuild = 'funnel_game_confirm_build',
        FunnelFinishedGameCount = 'funnel_finished_game_',
        FunnelStartedMultiplayerRoom = 'funnel_started_multiplayer_room',
        FunnelLoggedIn = 'funnel_logged_in',
        FunnelPurchasedPack = 'funnel_purchased_pack',

        // General
        GeneralBrokenInternetConnection = 'general_broken_internet_connection',
        AutoRejoinGame = 'auto_rejoin_game',
        ClickedAdblockAd = 'clicked_adblock_ad',
        GeneralPatchNotePopupSeconds = 'general_patch_note_popup_seconds',
        GeneralShowingPatchNotePopup = 'general_showing_patch_note_popup',
        GeneralUsesAdblock = 'general_uses_ad_block',
        GeneralDoesntUseAdblock = 'general_doesnt_use_ad_block',
        GeneralWebGLEnabled = 'general_webgl_enabled',
        GeneralWebGLDisabled = 'general_webgl_disabled',

        // Lobby
        ClickedLobbyMainCTA = 'clicked_lobby_maincta', // not used
        ClickedCreateRoom = 'clicked_create_room',
        ClickedVSBots = 'clicked_vs_bots', // not used

        ClickedFastRandomBotGame = 'clicked_fast_random_bot_game',
        ClickedJoinRoom = 'clicked_join_room',
        ClickedSpectate = 'clicked_spectate',
        ClickedReconnectGame = 'clicked_reconnect_game',
        ClickedPassTutorial = 'clicked_pass_tutorial',
        ClickedStore = 'clicked_store',
        ClickedLobbyPatchnotes = 'clicked_patchnotes',
        ClickedLobbyGames = 'clicked_lobby_games',
        ClickedLobbyRefresh = 'clicked_lobby_refresh',
        ClickedLobbyRoomsTab = 'clicked_lobby_roomstab',
        ClickedLobbySpectateTab = 'clicked_lobby_spectatetab',

        // Landing Page
        ClickedEnterLobby = 'clicked_enter_lobby', // Not used
        ClickedLandingPageMainCTA = 'clicked_landingpage_maincta', // Not used
        ClickedLandingPageVSBots = 'clicked_landingpage_vsbots',
        ClickedLandingPagePlayWithFriends = 'clicked_landingpage_playwithfriends', // Not used
        ClickedLandingPageExploreModes = 'clicked_landingpage_exploremodes', // Not used
        ClickedLandingPageOpenApp = 'clicked_landingpage_openapp', // Not used

        // Room
        ClickedRoomReadyToStart = 'clicked_room_ready_to_start',
        ClickedRoomStartGame = 'clicked_room_start_game',
        ClickedRoomCustomPlayOrderSelection = 'clicked_room_custom_play_order_selection',
        ClickedRoomKickPlayer = 'clicked_room_kick_player',
        ClickedRoomAddBot = 'clicked_room_add_bot',
        ClickedRoomSettingChangePrivateGame = 'clicked_room_setting_change_private_game',
        ClickedRoomSettingChangeNoTrollsSetting = 'clicked_room_setting_change_high_karma_game',
        ClickedRoomSettingUpdateGameModeSetting = 'clicked_room_setting_update_game_mode_setting',
        ClickedRoomSettingUpdateMapSetting = 'clicked_room_setting_update_map_setting',
        ClickedRoomSettingUpdateDiceSetting = 'clicked_room_setting_update_dice_setting',
        ClickedRoomSettingChangeVictoryPointsToWin = 'clicked_room_setting_change_victory_points_to_win',
        ClickedRoomSettingChangeGameSpeed = 'clicked_room_setting_change_game_speed',
        ClickedRoomSettingChangeBotSpeed = 'clicked_room_setting_change_bot_speed', // Not used
        ClickedRoomSettingChangeCardDiscardLimit = 'clicked_room_setting_change_card_discard_limit',
        ClickedRoomSettingChangeFriendlyRobber = 'clicked_room_setting_change_friendly_robber',
        ClickedRoomSettingChangeHideBankCards = 'clicked_room_setting_change_hide_bank_cards',
        ClickedRoomSettingChangeMaxPlayers = 'clicked_room_setting_change_max_players',
        ClickedRoomSettingChangePlayOrderSelection = 'clicked_room_setting_change_play_order_selection',
        ClickedRoomExit = 'clicked_room_exit',
        ClickedRoomMapPreview = 'clicked_room_map_preview',
        ClickedRoomGameSpeedInfo = 'clicked_room_game_speed_info',

        // Game
        ClickedGameLobbyButton = 'clicked_game_lobby_button',
        ClickedGameLobbyButtonAccept = 'clicked_game_lobby_button_accept',
        ClickedGameSoundButton = 'clicked_game_sound_button',
        ClickedGameSettingsButton = 'clicked_game_settings_button',
        ClickedGameRulesButton = 'clicked_game_rules_button',
        ClickedGameTradeButton = 'clicked_game_trade_button',
        ClickedGameCardForTrade = 'clicked_game_card_for_trade',
        GameFramesPerSecond = 'game_frames_per_second',

        // End Game
        ClickedEndGameOverview = 'clicked_endgame_overview',
        ClickedEndGameDiceStats = 'clicked_endgame_dice_stats',
        ClickedEndGameResourceCardStats = 'clicked_endgame_resource_card_stats',
        ClickedEndGameDevelopmentCardStats = 'clicked_endgame_development_card_stats',
        ClickedEndGameResourceStats = 'clicked_endgame_resource_stats',
        ClickedEndGameActivityStats = 'clicked_endgame_activity_stats',
        ClickedEndGameReturnToMap = 'clicked_endgame_return_to_map',
        ClickedEndGameRematch = 'clicked_endgame_rematch',
        ClickedEndGameLobby = 'clicked_endgame_lobby',
        ClickedEndGameSignup = 'clicked_endgame_signup',

        // Profile
        ClickedProfilePrivateAd = 'clicked_profile_private_ad',
        ClickedProfileSearch = 'clicked_profile_search',
        ClickedProfileDropdown = 'clicked_profile_dropdown',
        ClickedProfileManageMembership = 'clicked_profile_manage_membership',

        // Store
        StoreClickedSubscribe = 'store_clicked_subscribe',
        StoreClickedActivate = 'store_clicked_activate',
        StoreClickedPurchaseCoin = 'store_clicked_purchase_coin',
        StoreClickedPurchaseCoinDiscord = 'store_clicked_purchase_coin_discord',
        StoreRequestedLogin = 'store_requested_login',
        StoreClickedLoginTrue = 'store_clicked_login_true',
        StoreClickedCategory = 'store_clicked_category',
        StoreClickedPurchaseItem = 'store_clicked_purchase_item',
        StoreClickedApprovePurchaseItem = 'store_clicked_approve_purchase_item',
        StoreSuccessfullyPurchasedItem = 'store_successfully_purchased_item',

        // Community
        CommunityClickedSubmitVideo = 'community_clicked_submit_video',
        CommunityClickedSubmitTournament = 'community_clicked_submit_tournament',
        CommunityClickedTournaments = 'community_clicked_tournaments',

        // Mobile
        MobileClickedBurgeButton = 'mobile_clicked_burger_button',

        // Header Profile
        HeaderProfileClickedLogin = 'header_profile_clicked_login',
        HeaderProfileClickedDropdown = 'header_profile_clicked_dropdown', // Not used
        HeaderProfileClickedViewStats = 'header_profile_clicked_viewstats', // Not used
        HeaderProfileClickedEditProfile = 'header_profile_clicked_editprofile', // Not used
        HeaderProfileClickedDefaultColor = 'header_profile_clicked_defaultcolor', // Not used
        HeaderProfileClickedEditName = 'header_profile_clicked_editname', // Not used
        HeaderProfileClickedEditAvatar = 'header_profile_clicked_editavatar', // Not used
        HeaderProfileClickedLogout = 'header_profile_clicked_logout', // Not used
        HeaderProfileClickedChangeIcon = 'header_profile_clicked_changeicon',
        HeaderProfileClickedChangeColor = 'header_profile_clicked_changecolor', // Not used
    }

    export enum GoogleTagManagerEvent {
        GameStarted = 'game_started',
        GameFinished = 'game_finished',
        UserClickedLoginButton = 'user_clicked_login',
        PurchaseCompleted = 'purchase_completed',
    }

    const singleOccurrenceEvents: { [key in CA.Label]?: UIGoogleAnalyticsEvent } = { }
    const internalSingleOccurrenceEvents: Map<AnalyticEventType, Set<number> > = new Map()
    const internalUniqueEvents: Set<string> = new Set()
    const sessionInitTime: number = Date.now().valueOf()

    export function onEvent(data: any, eventType: UIGameEventEnums) {
        for(const label in singleOccurrenceEvents) {
            const event: UIGoogleAnalyticsEvent = singleOccurrenceEvents[label]

            if(event.sendAndInvalidateOn === eventType) {
                if(event.amount > 0) sendGoogleAnalyticsEvent(event.category, event.label, event.amount)

                delete singleOccurrenceEvents[label]
            }
        }
    }

    export async function initLogRocket() {
        logRocket = new LogRocketController()
        await logRocket.init()
    }

    export function initializeSessionRecorder() {
        sessionRecorder = new UISessionRecorder()
    }

    /**
     * @deprecated Please use sendAnalyticEvent instead.
     */
    export function sendGoogleAnalyticsEvent(category: Category, label: Label | string, value?: any) {
        if(!UIUtilsEjsVariables.analyticsActive) return
        if(isCrawler()) return

        sendEventGtag(category, label, value)
    }

    export function sendGoogleAnalyticsEventOnce(category: Category, label: Label | string, invalidateEventOn?: UIGameEventEnums) {
        if(singleOccurrenceEvents[label] === undefined) {
            registerSingleOccurrenceEvent(category, label, invalidateEventOn)
            sendGoogleAnalyticsEvent(category, label)
        }
    }

    export function sendEventSummed(category: Category, label: Label, sendAndInvalidateEventOn: UIGameEventEnums) {
        const event = singleOccurrenceEvents[label] ?? registerSingleOccurrenceEvent(category, label, sendAndInvalidateEventOn)
        event.amount += 1
    }

    const registerSingleOccurrenceEvent = (category: CA.Category, label: CA.Label | string, invalidateEventOn?: UIGameEventEnums): UIGoogleAnalyticsEvent => {
        const event: UIGoogleAnalyticsEvent = {
            category: category,
            label: label,
            sendAndInvalidateOn: invalidateEventOn,
            amount: 0,
        }

        singleOccurrenceEvents[label] = event

        return event
    }

    export async function sendAnalyticEvent(data: AjaxDataTypes.AnalyticData) {
        if(!UIUtilsEjsVariables.analyticsActive) return
        if(isCrawler()) return
        await UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiAnalytics(), data, undefined)
    }

    export async function sendAnalyticEventsWithMobileDimensions(data: AjaxDataTypes.AnalyticData) {
        if(!UIUtilsEjsVariables.analyticsActive) return
        if(isCrawler()) return

        const dimensions = {
            isApp: UIUtilsEjsVariables.isUserOnMobileAppOrWeb,
            isTablet: UIDeviceController.isUserOnTabletApp(),
            isAndroid: navigator.userAgent.includes('Android'),
            isPortrait: UIUtilsEjsVariables.shouldDisplayNewMobileGameUI,
            gameType: uiGameManager?.gameController?.gameSettings?.gameType,
            eloType: uiGameManager?.gameController?.gameSettings?.eloType,
            ...data.dimensions,
        }

        await sendAnalyticEvent({...data, dimensions: dimensions})
    }

    export async function sendAnalyticEventOnce(data: AjaxDataTypes.AnalyticData) {
        if(data.floatValue == undefined && internalSingleOccurrenceEvents.has(data.type)) return

        if(!internalSingleOccurrenceEvents.has(data.type)) internalSingleOccurrenceEvents.set(data.type, new Set<number>())
        if(data.floatValue == undefined) return sendAnalyticEvent(data)

        const existingFloatValues = internalSingleOccurrenceEvents.get(data.type)
        if(existingFloatValues?.has(data.floatValue)) return

        existingFloatValues?.add(data.floatValue)
        return sendAnalyticEvent(data)
    }

    export async function sendTimedAnalyticEventOnce(data: AjaxDataTypes.AnalyticData) {
        const uniqueEventId = `${data.type}_${data.stringValue || ''}`
        if(internalUniqueEvents.has(uniqueEventId)) return
        internalUniqueEvents.add(uniqueEventId)
        const currentTime = Date.now().valueOf()
        data.floatValue = (currentTime - sessionInitTime) / 1000
        return sendAnalyticEvent(data)
    }

    export function sendGoogleTagManagerEvent(event: CA.GoogleTagManagerEvent) {
        if(!UIUtilsEjsVariables.analyticsActive) return
        if(UIUtilsEjsVariables.isUserOnDiscord) return
        if(isCrawler()) return

        (window as any).dataLayer?.push({event: event})
    }
}
function sendEventGtag(category: CA.Category, label: CA.Label | string, value?: any) {
    if(UIUtilsEjsVariables.isUserOnDiscord) return
    gtag('event', category, {
        /* eslint-disable  @typescript-eslint/naming-convention */
        event_label: label,
        value: value,
    })
}

